<template>
  <div class="detail-drawer">
    <!-- <div class="title">商品详情</div> -->
    <div class="container" v-loading="loading">
      <div class="detail-item" style="display: flex; justify-content: space-between">
        <div class="info">
          <h5>{{ detail.title }}</h5>
          <span>
            <label>SPU：</label>
            {{ detail.id }}
          </span>
          <span>
            <label>{{ $t('stores::products-info::goods_cate') }}：</label>
            {{ detail.categoryNames }}
          </span>
          <span>
            <label>{{ $t('stores::products-info::supplier') }}：</label>
            {{ detail.supplier }}
          </span>
          <span>
            <label>{{ $t('stores::products-info::currency') }}：</label>
            {{ detail.spuCurrency }}
          </span>
        </div>
        <img :src="detail.spuImages && detail.spuImages[0]" style="width: 120px; height: 120px" />
      </div>

      <div class="detail-item">
        <div class="title">{{ $t('stores::products-info::photos') }}</div>
        <div class="images-list">
          <el-popover
            v-for="(item, index) in detail.spuImages"
            :key="index"
            class="images"
            placement="top-start"
            trigger="hover"
          >
            <img :src="item" style="width: 150px; height: 150px" />
            <img :src="item" style="width: 150px; height: 150px" slot="reference" />
          </el-popover>
        </div>
      </div>

      <div class="detail-item">
        <div class="title">{{ $t('stores::products-info::goods_sku') }}</div>
        <el-row :gutter="20">
          <el-col class="sku" v-for="(item, index) in detail.skus" :key="index">
            <div class="sku-item">
              <img :src="item.imageUrl" style="width: 120px; height: 120px" />
              <div class="sku-content">
                <div>
                  <label class="label">SKU</label>
                  <span>{{ item.id }}</span>
                </div>
                <div>
                  <label class="label">{{ $t('stores::products-info::purchase_price') }}</label>
                  <span>{{ $dataCheck(item.purchasePrice) }}(￥)</span>
                </div>

                <div>
                  <label class="label">{{ $t('stores::products-info::compare_at_price') }}</label>
                  <span>{{ $dataCheck(item.compareAtPrice) }}($)</span>
                </div>
                <div>
                  <label class="label">{{ $t('stores::products-info::sale_price') }}</label>
                  <span>{{ $dataCheck(item.salePrice) + '($)' }}</span>
                </div>
                <div>
                  <label class="label">{{ $t('stores::products-info::goods_stock') }}</label>
                  <span>{{ $dataCheck(item.skuInventory) }}</span>
                </div>
                <div>
                  <label class="label">{{ $t('stores::products-info::safe_stock') }}</label>
                  <span>{{ $dataCheck(item.safeInventory) }}</span>
                </div>
                <div>
                  <label class="label">{{ $t('stores::products-info::weight') }}</label>
                  <span>{{ $dataCheck(item.weight) }}{{ item.weightUnit }}</span>
                </div>
                <div v-for="(option, oIndex) in item.options" :key="oIndex">
                  <label class="label">{{ option.name }}</label>
                  <span>{{ option.value || '--' }}</span>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>

      <div class="detail-item">
        <div class="title">{{ $t('stores::products-info::goods_chart') }}</div>
        <rich-editor v-model="spuSizeDesc" :placeholder="$t('stores::products-info::input_goods_chart')"></rich-editor>
      </div>

      <div class="detail-item">
        <div class="title">{{ $t('stores::products-info::goods_detail') }}</div>
        <rich-editor v-model="spuLongDesc" :placeholder="$t('stores::products-info::input_goods_detail')"></rich-editor>
      </div>
    </div>
  </div>
</template>

<script>
import RichEditor from '@/components/rich-editor'
import { getProduct } from '@/server/product'
export default {
  props: {
    id: {
      type: [Number, String],
      default: null,
    },
    isShowDetailDrawer: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    RichEditor,
  },
  data() {
    return {
      loading: false,
      spuSizeDesc: '',
      spuLongDesc: '',
      detail: {},
    }
  },
  watch: {
    isShowDetailDrawer: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getProdDetail(this.id)
        }
      },
    },
  },
  methods: {
    async getProdDetail(id) {
      this.loading = true
      const res = await getProduct(id)
      this.loading = false
      if (res.data.code === this.$code) {
        this.detail = res.data.data
        this.spuSizeDesc = this.detail.spuSizeDesc
        this.spuLongDesc = this.detail.spuLongDesc
      }
    },
  },
}
</script>

<style scoped lang="scss">
.detail-drawer {
  padding: 0 10px;
  //   overflow: hidden;
  //   display: flex;
  //   flex-direction: column;
  .title {
    font-size: 16px;
    font-weight: 500;
    color: #010517;
    line-height: 40px;
    border-bottom: 1px solid #ebeef5;
    margin-bottom: 10px;
  }
  .container {
    // flex: 1;
    // overflow: auto;
  }
  .detail-item {
    margin: 20px 0;
  }
  .info {
    display: flex;
    flex-direction: column;
    h5 {
      font-size: 18px;
      margin-bottom: 20px;
    }
    label {
      width: 70px;
      display: inline-block;
    }
    span + span {
      margin-top: 10px;
    }
  }
  .images-list {
    display: grid;
    grid-template-columns: repeat(auto-fill, 140px);
    grid-gap: 20px 20px;
    // display: flex;
    // flex-wrap: wrap;
    // .images + .images {
    //   margin-left: 20px;
    // }
  }
  .sku-item {
    border: 1px solid #ebeef5;
    padding: 10px;
    display: flex;
    .label {
      width: 70px;
      display: inline-block;
    }
  }
  .sku + .sku {
    margin-top: 10px;
  }
  .sku-content {
    margin-left: 20px;
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    div {
      width: 50%;
      word-break: break-all;
    }
  }
}
</style>
